import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IErrorLog } from '../../../../model/error-logs';

@Component({
    selector: 'app-error-log-detail-dialog',
    templateUrl: './error-log-detail-dialog.component.html',
    styleUrls: ['./error-log-detail-dialog.component.scss']
})
export class ErrorLogDetailDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ErrorLogDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public errorLog: IErrorLog
    ) {}
}
